module.exports = __webpack_public_path__ + "static/media/banner.794b6193.jpeg";